import { createApiSlice } from "@common";
import { CRUD_EMPLOYEE_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addEmployeeType",
    method: "post",
    url: CRUD_EMPLOYEE_TYPE,
    stateKey: "message",
  },
  {
    name: "getEmployeeType",
    method: "get",
    url: CRUD_EMPLOYEE_TYPE,
    stateKey: "data",
  },
  {
    name: "getEmployeeTypeById",
    method: "get",
    url: CRUD_EMPLOYEE_TYPE,
    stateKey: "data",
  },
  {
    name: "updateEmployeeType",
    method: "put",
    url: CRUD_EMPLOYEE_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteEmployeeType",
    method: "delete",
    url: CRUD_EMPLOYEE_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "productType",
  apiConfig,
  customReducers,
);
const employeeTypeSlice = slice;

export default employeeTypeSlice.reducer;

export const {
  addEmployeeType,
  getEmployeeType,
  getEmployeeTypeById,
  updateEmployeeType,
  deleteEmployeeType,
} = thunks;
export const { rowSelect } = actions;
